import type { PlannerCapabilities } from '@hopdrive/feature-move-planner';

/**
 * The embed planner's behaviour, laid over the Dealer defaults. The
 * dealer-only capabilities are off, and where the two portals differ the embed
 * keeps its own side.
 */
export const EMBED_CAPABILITIES: Partial<PlannerCapabilities> = {
  roCapture: false,
  dynamicWorkflowSteps: false,
  confirmationContacts: false,
  contactsFromSourceMove: false,
  contactsAutofill: false,
  rideshareForReturn: false,
  enforcementMode: false,
  overlapEnforcement: false,
  driverRows: false,
  suggestedTimes: false,
  serviceLocations: false,
  lanePairReuse: false,
  laneMap: false,
  eventlogAudit: false,
  vinDecoder: false,
  programCoverage: false,
  appointmentMode: false,
  scheduledFromPlanningContext: false,
  liveRegionGate: false,
  timeValidityCheck: false,
  loanerSwapOnTypeChange: true,
  productChoiceSwitch: false,
  workflowsetResetToFirstListed: true,
  defaultWorkflowsetWithSourceMove: false,
  programAdminsMayPlan: false,
  separateTimeSection: false,
  swapHiddenForValet: false,
  notesLabelOptional: true,
  emailCopy: 'emails-to-notify',
  laneFailureCopy: 'alert',
  laneEndpointsFromLocations: true,
  googleSuggestionsCopy: false,
  optionalVehicleBlurb: true,
  loanerNoticeAsksForDetails: true,
  referenceIdFromLookup: true,
  priceNoteFullWidth: false,
};
